<template>
    <v-progress-linear
        background-color="#ffb364"
        :indeterminate="true"
        :height="progressBarHeight"
        class="app-loader-progress-bar pa-0 ma-0"
    />
</template>

<script>
export default {
    props: {
        height: {
            type: Number,
            default: 5
        }
    },
    computed: {
        progressBarHeight() {
            return this.$config.APP_PROGRESS_BAR_HEIGHT || this.height;
        }
    }
};
</script>

<style scoped>
.app-loader-progress-bar {
    position: fixed;
    top: 0;
    z-index: 500;
}
</style>
